import CreateEventPageComponent from "./components/CreateEventPageComponent";
import axios from "axios";
import {
  uploadImagesApiRequest,
  uploadImagesCloudinaryApiRequest,
} from "./utils/utils";
import { useSelector } from "react-redux";
import { newCategory,deleteCategory, saveAttributeToCatDoc } from "../../redux/actions/categoryActions";
import { useDispatch } from "react-redux";

const createEventApiRequest = async (formInputs) => {
  const { data } = await axios.post(`/api/events/admin`, { ...formInputs });
  return data;
};

const AdminCreateEventPage = () => {
  
  const { categories } = useSelector((state) => state.getCategories);
  // api types

  const dispatch = useDispatch();

  return (
    <CreateEventPageComponent
      createEventApiRequest={createEventApiRequest}
      uploadImagesApiRequest={uploadImagesApiRequest}
      uploadImagesCloudinaryApiRequest={uploadImagesCloudinaryApiRequest}
      categories={categories}
      reduxDispatch={dispatch}
      newCategory={newCategory}
      deleteCategory={deleteCategory}
      saveAttributeToCatDoc={saveAttributeToCatDoc}
    />
  );
};

export default AdminCreateEventPage;
